<template>
  <div class="history contents">
    <div>
      <form-date-range
        v-if="paymentSystemType !== 3"
        @changeDate="changeDate"
      />
      <div v-else class="inpay_period">
        <div class="inpay_period_title">{{ $t('my.search_period') }}:</div>
        <PeriodSetting @changeDate="changeDate" />
      </div>
    </div>
    <!--TODO: 아래 주석 되어있는 구매역과 alltem 구매내역이 다르기 때문에 분기 처리가 필요함-->
    <div class="list" v-if="purchase.purchaseList.length">
      <ul>
        <wrap-list-item
          v-for="(purchase, index) in purchase.purchaseList"
          :key="index"
          :propsdata="purchase"
        ></wrap-list-item>
      </ul>
      <ListPagination
        :pageNo="purchase.pageNo"
        :totalPageCount="purchase.totalPageCount"
        @changePage="handleChangePage"
      />
    </div>
    <ul v-else-if="paymentSystemType === 3 && alltemPurchaseProductList.length">
      <div
        v-for="(product, index) in alltemPurchaseProductList"
        class="alltem_history"
        :key="index"
        @click="goToAlltemPurchaseView(product)"
      >
        <span class="alltem_history_date">
          {{ product.purchaseDate }}
        </span>
        <div class="alltem_history_info">
          <div class="alltem_history_name">
            {{ product.productName }}
          </div>
          <div class="alltem_history_detail">
            <span class="alltem_history_quantity">
              {{ product.purchaseTotalCount }}개
            </span>
            <span class="alltem_history_bar"></span>
            <span class="alltem_history_price">
              {{ product.purchaseTotalAmount.addComma() }}
            </span>
          </div>
        </div>
      </div>
    </ul>
    <contents-none
      v-else
      :noneText="$t('my.no_purchase_history_for_period')"
    ></contents-none>
  </div>
</template>
<script>
import FormDateRange from '@/views/base/FormDateRange'
import WrapListItem from '@/views/my/WrapListItem'
import PeriodSetting from '@/views/my/PeriodSetting'
import ListPagination from '@/views/my/ListPagination'
import ContentsNone from '@/views/base/ContentsNone'
import { mapActions, mapGetters } from 'vuex'
import mixin from '@/utils/mixin'

export default {
  mixins: [mixin],
  components: {
    PeriodSetting,
    FormDateRange,
    WrapListItem,
    ContentsNone,
    ListPagination
  },
  data() {
    return {
      dateRange: '',
      config: {
        static: true,
        altFormat: 'Y-m-d',
        altInput: true,
        dateFormat: 'Y-m-d',
        mode: 'range',
        locale: this.dateLocale,
        monthSelectorType: 'static',
        maxDate: this.$moment().format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapGetters('main', ['paymentSystemType', 'shopId']),
    ...mapGetters('my', [
      'purchase',
      'alltemPurchaseProductList',
      'alltemPurchaseStartDate',
      'alltemPurchaseEndDate'
    ])
  },
  methods: {
    ...mapActions('my', ['getPurchaseList', 'getAlltemPurchaseProductList']),
    changeDate(inpaySelectedDate) {
      // date component에서 date를 시작 시점에 한번 update하기 떄문에 해당 메서드가 init 시점에 호출 됨
      if (this.paymentSystemType === 3) {
        this.getAlltemPurchaseProductList(inpaySelectedDate)
      } else {
        this.getPurchaseList({ reset: true, pageNo: 1 })
      }
    },
    goToAlltemPurchaseView(product) {
      this.$router.push({
        name: 'alltemPurchaseDetail',
        params: {
          ...product,
          shopId: this.shopId
        }
      })
    },
    handleChangePage(pageNo) {
      window.scrollTo(0, 0)
      this.getPurchaseList({
        reset: false,
        pageNo
      })
    }
  },
  mounted() {},
  destroyed() {}
}
</script>

<style lang="scss">
.history {
  .inpay_period {
    font-family: 'Noto Sans KR';
    font-size: 16px;
    display: flex;
    align-items: center;
    z-index: 99;
    position: relative;
    padding: 12px 12px 10px 16px;
    margin-bottom: 10px;
    background-color: #fff;
    border-bottom: 1px solid #efefef;
    .inpay_period_title {
      margin-right: 13px;
    }
  }
  .btMore {
    width: 100%;
    height: 39px;
    padding-top: 1px;
    color: #8b8b91;
    font-size: 14px;
    background-color: #fff;
    border-bottom: 1px solid #efefef;
    overflow: hidden;
    .icon {
      margin: 0 0 3px 4px;
    }
  }
  .list > ul > li,
  .view {
    position: relative;
    margin: 0 0 10px;
    background-color: #fff;
  }
  dl {
    display: block;
  }
  .purchaseDate {
    height: 31px;
    padding: 11px 0 0 16px;
    font-size: 11px;
    font-weight: bold;
    border-bottom: 1px solid #d6d6db;
  }
  .btDetail {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 11px;
    color: #636376;
    .icon {
      margin: -1px 0 0 3px;
    }
  }
  .purchaseNum {
    height: 31px;
    padding: 10px 16px 0 0;
    margin-top: -31px;
    font-size: 11px;
    color: #636376;
    text-align: right;
    dt,
    dd {
      display: inline-block;
    }
    dt::after {
      content: '|';
      margin: 0 3px;
    }
  }
  .purchaseProducts,
  .purchasePrice {
    height: 21px;
    font-size: 12px;
    dt,
    dd {
      display: block;
      padding-top: 10px;
      width: 100%;
    }
    dt {
      height: 21px;
      color: #636376;
    }
    dd {
      height: 21px;
      padding-left: 93px;
      margin-top: -21px;
    }
  }
  .purchase .purchaseProducts dd {
    padding-right: 22px;
  }
  .purchaseProductsList {
    padding-top: 9px;
    margin-top: 10px;
    font-size: 11px;
    border: 1px solid #e3e4eb;
    background-color: #f0f1f7;
    li {
      margin: 0 16px;
    }
    span {
      display: block;
      height: 19px;
    }
    span:first-child {
      color: #636376;
    }
    span:last-child {
      margin-top: -19px;
      text-align: right;
    }
  }
  .msg {
    padding-bottom: 7px;
    li {
      position: relative;
      padding: 9px 16px 0 24px;
      font-size: 11px;
      color: #636376;
      line-height: 14px;
      &:before {
        content: '*';
        position: absolute;
        top: 10px;
        left: 16px;
        display: block;
      }
    }
  }
  .alltem_history {
    background-color: white;
    padding: 12px 16px;
    border-bottom: #ededed 1px solid;
    &:hover {
      background-color: #efeafe;
    }
    .alltem_history_date {
      font-family: 'Noto Sans KR';
      font-size: 13px;
      color: #636376;
    }
    .product_name {
      font-family: 'Noto Sans KR';
      font-size: 15px;
      color: #151721;
    }
    .alltem_history_info {
      display: flex;
      margin-top: 8px;
      justify-content: space-between;
      font-family: 'Noto Sans KR';
      .alltem_history_name {
        font-size: 15px;
        color: #151721;
      }
      .alltem_history_detail {
        display: flex;
        align-items: center;
        font-family: 'Noto Sans KR';
        .alltem_history_price {
          font-weight: bold;
          font-size: 15px;
          color: #151721;
        }
        .alltem_history_quantity {
          font-size: 13px;
          color: #636376;
        }
        .alltem_history_bar {
          width: 1px;
          height: 10px;
          margin: 0 6px 2px 6px;
          background-color: #a5a5ac;
        }
      }
    }
  }
}
</style>
